<template>
  <div @click='close()' class="keyword-modal-backdrop">
    <div class="keyword-modal" role='dialog' aria-modal="true" :aria-label="$t('text.definition')">
      <header class="keyword-modal-header">
        <slot name="header">
          <button
            type="button"
            class="btn-close"
            @click="close"
            :aria-label="$t('text.close')"
          >
          X
          </button>
        </slot>
      </header>
      <section class="keyword-modal-body">
        <slot name="body">
        </slot>
       </section>
    </div>
  </div>
</template>

<script>
  export default {
    name: "modal",
    methods: {
      close() {
        document.getElementsByTagName("body")[0].classList.remove("modal-open");
        this.$emit("close");
      },
    }
  }
</script>

<style>
  .keyword-modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:3;
  }

  .keyword-modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 780px;
    max-height:80vh;
  }

  .keyword-modal-header {
    text-align:right;
  }

  .keyword-modal-header {
    color: #4AAE9B;
    justify-content: space-between;
  }

  .keyword-modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .keyword-modal-body {
    position: relative;
    padding-bottom: 50px;
    padding-left: 50px;
    padding-right: 50px;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 10px;
    padding-right:15px;
    cursor: pointer;
    font-weight: bold;
    color: #000000;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>